import { notification } from "antd";
import { action, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../common/Api";
import { sleep } from "../../common/Utils";
import { OrgStore } from "./OrgStore";

export class OrgAddUserFromEmailStore {
  orgStore: OrgStore;

  visible = false;
  loading = false;
  saving = false;

  email: string = "";
  user?;

  get canSave() {
    if (!this.user) return false;

    return this.user.children.filter((x) => x.checked).length > 0;
  }

  constructor(orgStore: OrgStore) {
    makeAutoObservable(this, {
      orgStore: false,
    });
    this.orgStore = orgStore;
  }

  @action onSearch(email) {
    this.email = email;
    if (!email) {
      this.user = null;
      return;
    }
    Api.user.findByEmailWithChildren(email).then((res) => {
      const users = res.data.findUserByEmail;
      const user = users.length === 1 ? users[0] : null;
      if (user) {
        user.children = user.children.map((c) => {
          c.checked = false;
          c.disabled = c.school?.id === this.orgStore.id;
          return c;
        });
      }
      runInAction(() => {
        this.user = user;
      });
    });
  }

  @action onSave() {
    return Api.family
      .changeChildrenSchool({
        schoolId: this.orgStore.id,
        childIds: this.user.children.filter((x) => x.checked).map((x) => x.childId),
      })
      .then(async () => {
        notification.success({ message: `Add user successed!` });
        this.orgStore.showAddUserDlg = false;
        this.user = null;
        await sleep(3000);
        this.orgStore.loadMembers();
      });
  }
}
